<template>

  <div class="new-home">

    <div class="direct-section">
      <div class="direct-item">
        <!-- <i class="iconfont icon-hospital"></i> -->
        <van-icon name="shopping-cart-o" />
        <span>网药直赔</span>
			<wx-open-launch-weapp
			
			id="launch-btn"
			style="position: absolute;top: 0;left: 0;z-Index: 2;opacity: 0.5;width: 100%;height: 100%;"
			username="gh_93d9392c28ed"
			path="pages/home/index?bbcShopId=111&lpzfParam=2222">
			<script type="text/wxtag-template">
				<span style="width:100%;height:100%;display: -webkit-box;padding:20px;">&nbsp;</span> 
			</script>	
			</wx-open-launch-weapp>		
      </div>
      <div class="direct-item" @click="toPay">
        <!-- <i class="iconfont icon-pharmacy"></i> -->
        <van-icon name="qr" />

        <span>药店直赔</span>
      </div>
    </div>
    <div style="position: relative; top: -100px; z-index: 1;">
        <div class="service-grid">
      <div class="service-item" v-for="(item, idx) in services" :key="idx+item.path" @click="() => item.mtd(item)">
			<img :src="item.icon" class="service-icon" />
			<span>{{item.text}}</span>
			<wx-open-launch-weapp
			v-if="item.text=='康颐药房'"
			id="launch-btn"
			style="position: absolute;top: 0;left: 0;z-Index: 2;opacity: 0.5;width: 100%;height: 100%;"
			username="gh_93d9392c28ed"
			:path="item.path">
			<script type="text/wxtag-template">
				<span style="width:100%;height:100%;display: -webkit-box;padding:20px">&nbsp;</span> 
			</script>	
			</wx-open-launch-weapp>
		  
      </div>
    </div>
    <div class="banner">
      
		<van-swipe
		:autoplay="3000"
		:show-indicators="true"
		indicator-color="white"
		@change="onChange"
		>
		<van-swipe-item v-for="(item, index) in adImgs" :key="index">
			<img
			:src="item.img"
			
			@click="doAd(item)"
			class="banner-img"
			/>
		</van-swipe-item>
		</van-swipe>

    </div>
    <div class="nearby-section">
	  <div style="display: flex;flex-direction: row;justify-content: space-between;align-items: center;">
      	<div class="nearby-title">健康资讯</div>
	  	<div class="nearby-title-right" @click="toJkzy">更多>></div>
	  </div>
      
	  <div class="card"  v-for="(item, index)  in zkzxlist" :key="index" @click="to_content(item.url)">
		<div class="up">
			<div class="card-box-img">
				<img :src="item.img" alt="">
			</div>
			<div class="card-left">
				<div>{{item.title}}</div>
				<div class="card-left-bot" v-show="false">
					<div>{{item.name}}</div>
					<div>{{item.time}}</div>
				</div>
			</div>
		</div>
	  </div>
    </div>
    </div>
  </div>

</template>

<script>

import wx from "weixin-js-sdk";

export default {
  name: 'fundHomePage',
  data() {
    return {
			targetMode:"min",
			current: 1,
			hasPwd: '', //是否设置过密码，没有则不允许进入京东商城
			showNotOpenServiceFlag: false, //控制遮罩层

			showNotPauseServiceFlag:false, //控制显示

			footBarActive:0,

			thirdShopMap: {},//三方数组map

			tryInitExQty:0,//微信初始化尝试次数

      services: [ //jkhealth kangyi,yct,heye
	    //{code:'jkhealth', icon: require('../../static/img/jd_icon.png'), text: '京东药房', mtd: this.toThirdShop},
        {code:'kangyi', icon: require('../../static/img/medicine_icon.png'), text: '康颐药房', mtd: this.toOnlineBuyKangyi,path:'pages/home/index?bbcShopId=111&lpzfParam=2222'},
        {code:'yct', icon: require('../../static/img/yst.png'), text: '壹参堂', mtd: this.toThirdShop},
        {code:'heye', icon: require('../../static/img/doctor_icon.png'), text: '荷叶', mtd: this.toThirdShop},
        {code:'zxwz', icon: require('../../static/img/chat_icon.png'), text: '在线问诊', mtd: this.myDialogTip},
        {code:'jkzx', icon: require('../../static/img/check_icon.png'), text: '健康资讯', mtd: this.toJkzy},
		{code:'fujinyd', icon: require('../../static/img/pharmacy.png'), text: '附近药店', mtd: this.toDurgList},		
        {code:'photo', icon: require('../../static/img/baoxianclaim.png'), text: '拍照理赔', mtd: this.toClaim },
		{code:'jkhealth', icon: require('../../static/img/chat_icon.png'), text: '金康药房', mtd: this.myDialogTip},

        
      ],
      tabs: ['全部', '医院', '药房', '中医门诊'],
      activeTab: 0,
      nearbyList: [
        { logo: require('../../static/img/payment.png'), name: '金象杭州翁乔路店', address: '南苑街道翁乔路175-177号一楼商铺', distance: '0.0km' },
        { logo: require('../../static/img/payment.png'), name: '金象东单北大街店', address: '东单北大街62号', distance: '1.9km' },
        { logo: require('../../static/img/payment.png'), name: '大参林12465店梧州龙...', address: '梧州市龙圩区龙城路', distance: '2.0km' }
      ],
	  //健康资讯
    zkzxlist: [
			{
			
						img: './img/yundong_1_a.png',
						title: '走路是最好的运动了！不了解这4个技巧，走了6000步也无用哦',
						name: '大川',
						time: '2个月前发布',
						eye: '999',
						comment: '999',
						star: '999',
						like: '999',
						url: "./word/yundong_1.html"
			
			},
			{
			
						img: './img/yangshen_1_a.png',
						title: '立秋后，抓住防大病的“黄金40天”！我们需要注意什么 ！',
						name: '大川',
						time: '2个月前发布',
						eye: '999',
						comment: '999',
						star: '999',
						like: '999',
						url: "./word/yangshen_1.html"
			
			},
			{
			
						img: './img/xinli_1_a.png',
						title: '情绪的影响力，坏情绪才是健康的“最大杀手”',
						name: '大川',
						time: '2个月前发布',
						eye: '999',
						comment: '999',
						star: '999',
						like: '999',
						url: "./word/xinli_1.html"
			
			}

		],
		
	  //轮播图
	  adImgs:[
		  {
			 img:require('../../static/img/1q11.png'),
		  	 code:"jkhealth" 
		  }		  
	  ]
    }
  },
  	// 生命周期 - 创建完成（可以访问当前this实例）
	created() {
		//this.queryDrugList();
		//sessionStorage.setItem('cstFullName', "杨长发");
		//sessionStorage.setItem('userPlnCode', "P0001");
	},
   mounted() {
		//this.init();
		//this.getShopUrls();
		this.initSync();
   },	
	methods: {

		//初始化同步处理
		async initSync(){

		  this.tryInitExQty = 0;
		  
          await this.init();
		  
		  console.log("init succeed");

		  			
		  await this.getShopUrls();

		console.log("getShopUrls succeed");

		  setTimeout(() => {
			  
			this.initMyWxConfig();

			console.log("initMyWxConfig succeed");

		  }, 500);

		},
		
		//根据编码获取shopurl
		getShopUrls(){
			let reqData ={
				lysCstUserId:sessionStorage.getItem('lysCstUserId'),
    			supCodes: 'jkhealth,kangyi,yct,heye',//供应商编码 都号分割
			}
			this.$getRequestData20('getThirdShops', reqData)
			.then(result => {
				if(result.resultCode == '0000'){
					
				
					console.log(result.bizData)
					
					this.thirdShopMap = result.bizData;

					//处理小程序  kangyi
					//let arr.map(m => m.get('key') ?? '默认');
					this.updatePathByCode('kangyi',this.thirdShopMap['kangyi']);

				}else{
					this.$toast.fail('获取链接失败');
				}

			})
		},

		//修改对象的path
		updatePathByCode(code, newPath) {
			const item = this.services.find(i => i.code === code);
			if (item) {
				item.path = newPath;
			}
		},

		//去第三方 只是支持h5
		toThirdShop(item){
			
			//判断是否设置直付密码
		    
			if(!this.validaHasDpcode()){

				this.$dialog.confirm({
					title: '安全提醒',
					message: '您尚未设置直付密码，建议立即设置。',
					confirmButtonText: '去设置',
					cancelButtonText: '下次再说'
				}).then(() => {
					 this.$router.push({ path: '/pay/payCode?hasPwd=n' });
				});

				return;
			}

			//从数值中获取url
			let shopCode = item.code;

			let thirdUrl = this.thirdShopMap[shopCode];

			window.location.href = thirdUrl;
		},

		//验证是否设置直付密码
		validaHasDpcode(){
			if(this.hasPwd == 'y'){ //判断是否设置过密码
				

				return true;
			}else
			{
				return false;
			}
		},

		toOnlineBuy(){
			

			if(!this.validaHasDpcode()){

				this.$dialog.confirm({
					title: '安全提醒',
					message: '您尚未设置直付密码，建议立即设置。',
					confirmButtonText: '去设置',
					cancelButtonText: '下次再说'
				}).then(() => {
					 this.$router.push({ path: '/pay/payCode?hasPwd=n' });
				});

				return;
			}

			let shopCode = "yct"; //默认去京东 jkhealth,kangyi,yct,heye

			let thirdUrl = this.thirdShopMap[shopCode];

			window.location.href = thirdUrl;			
		},	
		//打开广告试图
		doAd(item){
			console.log(item);
		},

		toJkzy(){
			window.location.href = "toInforH5.html";
		},


		toPay(){
			//this.toPukangByH5("SMZF");
			this.$router.push({ path: '/ability/paymentPage' })
			//window.location.href = "https://pk-pl-h5-test.pukangbao.com/scanning-code-page?cardCode=2023081500000079&signMD5=cc6409a1a22c1983f8d40e9b46ab004f&terminal=18&platformCode=lys&terminalType=3&thirdUserCode=511112195312191411";
		},
		toClaim()
		{
			//this.toPukangByH5("KSLP-LPJL");
			//window.location.href = "https://pk-pl-h5-test.pukangbao.com/storeCollectionTP?cardCode=2023081500000079&signMD5=cc6409a1a22c1983f8d40e9b46ab004f&terminal=18&platformCode=lys&terminalType=3&thirdUserCode=511112195312191411";
			window.location.href="http://vueh5test.ebao51.cn/H5/jkxclaim/claim_fund.html";
		},

		toDurgList(){
			this.$router.push({ path: '/index/drugListPage' })
		},

		myDialogTip(){
			this.$dialog.alert({
			message: '开发集成中',
			}).then(() => {
			// on close
			});
		},
		onChange() {

		},
		init(){
			let {mode,lysCstUserId} = this.$route.query; //获取query
			
			mode = "h5";

			if(!lysCstUserId) 
				lysCstUserId= sessionStorage.getItem("lysCstUserId");//'899aa38caf709598686321c2ab93dce7a945b578ae4c9a34d3ab6ac674b00cf4d61e9b9b252939e0c15d6f46234b56a6';
			
			sessionStorage.setItem('lysCstUserId', lysCstUserId);
			
			if(!mode) 
				mode= sessionStorage.getItem("mode");//'899aa38caf709598686321c2ab93dce7a945b578ae4c9a34d3ab6ac674b00cf4d61e9b9b252939e0c15d6f46234b56a6';

			sessionStorage.setItem('mode', mode);
			this.targetMode = mode;

			let data = {
				lysCstUserId
			}
			console.log(data)

			
			this.$getRequestData20('queryCstUserData', data)
			.then(result =>{

				console.log(result);

				if(result.resultCode !== '0000'){
 					this.showNotOpenServiceFlag = true;
					
					this.$toast.fail(result.msg);

					this.toLoginPage();
				}else{
					let {hasPwdFlag} = result.bizData;

					if(!hasPwdFlag)
						hasPwdFlag ='n';

					this.hasPwd = hasPwdFlag; 

					sessionStorage.setItem('hasPayPwd', hasPwdFlag);

					//this.initMyWxConfig();
				}
			})
			.catch(err => {
				console.log(err);
				this.$toast.fail(err);
				this.showNotOpenServiceFlag = true;
			})
		},

		toLoginPage(){
			
			 this.$router.push({ path: '/login/loginPage' });
		},

		queryDrugList(){


			let data = {
				jingdu:null,//  精度
            	weidu:null,//  维度
            	keyData:"",
			}
        			
			this.$getRequestData20('querySupplierList', data)
			.then(result =>{

				console.log(result);

				if(result.resultCode !== '0000'){
 					
					
					this.$toast.fail(result.msg);

					this.toLoginPage();
				}else{

					this.nearbyList = result.bizData;

				}
			})
			.catch(err => {
				console.log(err);
				this.$toast.fail(err);
				
			})
    	},
        //拨打电话
        calPhone(phone){
          window.location.href = `tel:${phone}`;
        },

		to_content(url) {
            window.location.href = url;
        },

        openBaiduMapWithAddress() {

            // 经纬度坐标（示例：天安门）
            //const lat = 39.915;
            //const lng = 116.404;
            const title = encodeURIComponent("天安门广场");
            
            // 构建百度地图URL
            const url = "https://map.baidu.com/?latlng=39.915,116.404&title="+title;
            
            // 新窗口打开
            window.open(url, '_blank');

        },

		initMyWxConfig() //初始化微信配置
		{
           let wxAppId = process.env.VUE_APP_WX_APP_ID;// lys:724039475503837184   yzf:1166419017226006528
            
			// 安全获取当前 URL（兼容 iOS 微信）
			const currentUrl = window.__wxOriginalUrl || document.URL;//document.URL; // 更可靠用于“读取”

			//alert(currentUrl);

            let bizData = {
                wxAppId: wxAppId, //默认值(配置区分生产/测试环境)
                httpUrl: currentUrl //当前页面url document.UR
            }
           
		   this.tryInitExQty = this.tryInitExQty+1;
            
            ///pc/wx/gzhweixinMgt/getSignature
            this.$getRequestCommon('/pc/wx/gzhweixinMgt/getSignature', bizData)
            .then(result =>{

              console.log(result);

              if(result.resultCode !== '0000'){
                

                this.$toast.fail(result.msg);

              }else{
                   let bizDataJson = result.bizData;

                   let appId = bizDataJson.wxGzhCorpCode; // 必填，公众号的唯一标识
                   let timestamp = bizDataJson.timestamp; // 必填，生成签名的时间戳
                   let nonceStr = bizDataJson.nonceStr; // 必填，生成签名的随机串
                   let signature = bizDataJson.signature; // 必填，签名
                   
                   //wx
                    wx.config({
                      debug: false, // 调试模式，生产环境建议关闭
                      appId: appId,
                      timestamp: timestamp,
                      nonceStr: nonceStr,
                      signature: signature,
					  jsApiList: ['openLaunchWeapp'], // 必填，需要使用的JS接口列表
                      openTagList: ['wx-open-launch-weapp'] // 必须包含这个
                    });

                    wx.ready(() => {
                      // 第三步：配置成功后再调用getLocation
					  console.log("wx  init succed");
                    });

                    wx.error((err) => {
                      console.error('JS-SDK配置失败：', err);
                      //alert('JS-SDK配置失败，请检查配置。错误信息：' + JSON.stringify(err));
					  if(this.tryInitExQty <= 3){//尝试2次
						  	setTimeout(() => {
			  
								this.initMyWxConfig();

								console.log("initMyWxConfig succeed");

							}, 1000);
					  }
                    });                   
              }
            })
            .catch(err => {
              console.log(err);
              this.$toast.fail(err);
              
            })   			
		},
		//打开康怡小程序（元素实现）
		openKangyiXcx(){

		
		}		

	},
}
</script>

<style scoped>

.new-home { background: #f7f8fa; }
.top-bar { display: flex; align-items: center; justify-content: space-between; padding: 16px; background: #2176ff; color: #fff; }
.location { font-size: 16px; }
.logo { height: 32px; }
.top-icons { display: flex; align-items: center; }
.dot, .line, .circle { width: 8px; height: 8px; border-radius: 50%; background: #fff; margin-left: 8px; }
.line { width: 16px; border-radius: 4px; }
.direct-section { 
  position: relative;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    /* align-items: center; */
    overflow: hidden;
    z-index: 1;
    padding: 0px 0 24px;
    border-bottom-left-radius: 110vw 120px;
    border-bottom-right-radius: 110vw 120px;
    background: #2176ff;
    height: 170px;
    color: #fff;
}
.direct-item { 
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 18px;
    margin-top: 25px; 
    position: relative;
}
.direct-item i { font-size: 32px; margin-bottom: 4px; }
.service-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 12px; background: #fff; padding: 12px 0 24px;     margin: 12px;  border-radius: 15px;}
.service-item { position: relative;display: flex; flex-direction: column; align-items: center; font-size: 14px; color: #333; }
.service-icon {  height: 36px; margin-bottom: 4px; }
.banner {    margin: 15px 10px; }
.banner img { width: 100%; border-radius: 8px; }
/* .nearby-section { background: #fff; margin: 0 0 16px; border-radius: 8px; padding: 16px; } */
.nearby-title { 
  font-size: 18px;     
  margin-bottom: 8px;
  text-align: left;
  margin-left: 15px; 
}
.nearby-title-right { 
  font-size: 15px;     
  margin-bottom: 8px;
  text-align: right;
  margin-left: 60%; 
  padding-right: 15px;
}
.nearby-tabs { display: flex; gap: 16px; margin-bottom: 12px; }
.nearby-tabs span { font-size: 15px; color: #888; cursor: pointer; }
.nearby-tabs .active { color: #2176ff; font-weight: bold; border-bottom: 2px solid #2176ff; }
.nearby-list { background-color: #fff;
    margin: 5px 15px;
    border-radius: 15px;}
.nearby-item {  
  display: flex;  border-bottom: 1px solid #f0f0f0;     padding: 15px 10px; 
  >div {
    display: flex; 
    flex-direction: column;
    justify-content: space-around;
  }
}
.nearby-logo { width: 45px; height: 45px; border-radius: 8px; margin-right: 12px; }
.nearby-info { flex: 1; text-align: left;}
.nearby-name { font-size: 15px;  }
.nearby-address { font-size: 12px; color: #888; }
.nearby-distance {  font-size: 12px;   color: #888;    align-items: end; }
.nearby-distance-logo{ width: 20px;}


        .card {
            padding: 12px;
            border-bottom: 1px solid rgba(238, 238, 238, 1);
        }

        .card>.up {
            display: flex;
        }

        .card-box-img {
            width: 30%;
        }

        .card-box-img>img {
            width: 100%;
        }

        .card-left {
            flex: 1;
            margin-left: 10px;
            font-size: 16px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
        }

        .card-left-bot {
            display: flex;
            justify-content: space-between;
            color: rgba(102, 102, 102, 1);
            font-size: 12px;
        }

        .card-bot {
            display: flex;
            justify-content: space-between;
            margin-top: 5px;
        }

        .card-bot>div {
            display: flex;
            width: 50px;
            justify-content: space-around;
        }
</style>
<style>
#app {
	margin-top: 0px !important;
}
</style>